import config from "../../config"
import RequestService from "../RequestService"

const updateLaborType = (id, params, successCallback, failureCallback) => {
  RequestService.patch(`${config.backendUrl}/labor_types/${id}`, { labor_type: params }, successCallback, failureCallback)
}

export default updateLaborType;